import NetAdmin from './src/netAdminPage';
import { NetAdminMenu } from './src/netAdminMenu';

export default {
	name: 'NetAdmin',
	page: NetAdmin,
	menu: NetAdminMenu,
	isCommunityProtected: true
};
